import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const ErrorMessageStyled = styled(Typography)`
  margin: 0.25rem 0.25rem 0;
`;
